import React from "react";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';

const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={1300}
    title={title}
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)

const Item = styled.div`
  /* background: #08091f; */
  border-radius: 6px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  display: flex;
  flex-basis: content;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  opacity: ${props => props.disabled ? props.hide ? 0 : 0.3 : 1};
  padding: 6px 4px;
  margin: 0px 2px;
  min-width: 50px;
  transition: 0.2s ease background;
  &:hover {
    background: ${props => props.disabled ? 'none' : '#e1e1e1'};
  }
  svg {
    /* fill: #FFF; */
    fill: ${props => props.iconColor ? props.iconColor : '#08091f'};
    height: 15px;
    /* height: 1.125rem;
    width: 1.125rem; */
  }

  span {
    /* color: #FFF; */
    color: ${props => props.iconColor ? props.iconColor : '#08091f'};
    font-size: .8rem;
    width: 24px;
    text-align: center;
  }
  p {
    /* color: #FFF; */
    color: #08091f;
    white-space: nowrap;
    /* padding-left: 8px; */
    font-size: .7rem;
    text-align: center;
    white-space: pre-line;
    padding-top: 2px;
    /* padding: 6px 4px; */
    /* margin: 4px 0px; */
    /* width: 100%; */
  }
`;

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
  span {
    font-size: .9rem;
    font-weight: normal;
    text-align: center;
    margin-bottom: 4px;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Row = ({children, style}) => {
  return (
    <ButtonRow style={style}>
      {children}
    </ButtonRow>
  )
}
export const Action = (props) => {
  if (props.tipText) {
    return (
      <DarkTooltip
        arrow
        title={
          <TipContent>
            <p>{props.tipText}</p>
          </TipContent> 
        }
      >
        <Item 
          onClick={props.onClick}
          disabled={props.disabled}
          style={props.style}
        >
          {props.icon}
          <p>{props.text}</p>
        </Item>
      </DarkTooltip>
    )
  }
  return (
    <Item 
      onClick={() => {
        props.onClick();
        if (props.hideOnClick && props.setAnchorEl) {
          props.setAnchorEl('')
        }
      }}
      iconColor={props.iconColor}
      disabled={props.disabled}
      hide={props.hide}
      style={props.style}
    >
      {props.icon}
      <p>{props.text}</p>
    </Item>
  );
};

